"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _link = _interopRequireDefault(require("./link"));
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Creates a `helpSnippet` content model
 *
 * @param {object} entry
 * @param {object} entry.sys
 * @param {string} entry.sys.id
 * @param {object} entry.fields
 * @param {string} entry.fields.title
 * @param {object} entry.fields.content
 * @param {boolean} entry.fields.accordion
 * @param {string} entry.fields.linkText
 * @param {string} entry.fields.externalLink - a URL
 * @param {object} entry.fields.internalLink - a reference to a Contentful entry
 * @param {boolean} entry.fields.noFollow
 * @param {boolean} entry.fields.newTab
 * @returns {object} `helpSnippet` content model
 */
var createHelpSnippet = function createHelpSnippet(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var document = (0, _utils.getProp)(fields, 'content');
  var content = document ? (0, _processRichText["default"])({
    document: document,
    factories: _standard["default"]
  }) : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    title: (0, _utils.getProp)(fields, 'title'),
    content: content,
    link: (0, _link["default"])({
      fields: fields
    }),
    accordion: (0, _utils.getProp)(fields, 'accordion'),
    markAsFaq: (0, _utils.getProp)(fields, 'markAsFaq')
  };
};
var _default = createHelpSnippet;
exports["default"] = _default;